import SelectField from '@pelckmans/elementis/components/select-field';
import { useTranslation } from 'react-i18next';
import { CurrentOrPreviousGroup } from '../../../../../../api/groups';
import { useResultsDataContext } from '../../../context/ResultsDataContext';
import { useSchools } from '../../../hooks/useSchools';
import { useFilters } from '../../../context/filter-context/FilterContext';

function buildSchoolName(school: CurrentOrPreviousGroup['school']) {
  if (!school.cities) return school.name;

  return `${school.name}, ${school.cities}`;
}

export default function SchoolFilter() {
  const { t } = useTranslation();
  const { selectedSchool, setSelectedSchool, selectedModule, selectedSchoolYear } = useFilters();
  const { scorableItems } = useResultsDataContext();

  const schools = useSchools(selectedSchoolYear);

  return (
    <SelectField
      value={selectedSchool || null}
      onChange={setSelectedSchool}
      renderValueContent={school => buildSchoolName(school)}
      required
      size="sm"
      aria-label={t('PAGES.RESULTS.FILTERS.SCHOOL_FILTER.A11Y_LABEL')}
      dropdownMenuProps={{
        ariaLabel: t('PAGES.RESULTS.FILTERS.SCHOOL_FILTER.DROPDOWN_MENU.A11Y_LABEL'),
      }}
      disabled={scorableItems.filter(x => x.module === selectedModule?.id).length === 0}
    >
      {schools?.map(school => (
        <SelectField.Item value={school} text={buildSchoolName(school)} key={school.id} />
      ))}
    </SelectField>
  );
}
